import { CUBE_DIMENSIONS } from "../../cube/dimensions";
import { createDimensionAnalysisView } from "./DimensionAnalysisView";

// ─────────────────────────────────────────────────────────────────────────────
// Analyse par Groupe (Groupe.dim)
// ─────────────────────────────────────────────────────────────────────────────
const GroupeView = createDimensionAnalysisView({
  dimension: CUBE_DIMENSIONS.groupe,
  type: "groupe",
  title: "Analyse Groupe",
  label: "Groupe",
  pluralLabel: "Groupes",
  one: "groupe",
  many: "groupes",
  searchPlaceholder: "Rechercher un groupe…",
});

export default GroupeView;
